
import { defineComponent } from 'vue';
import store from "@/store";

interface Navigation {
  lesson: Boolean,
  editor: Boolean,
  output: Boolean,
}

export default defineComponent({
  data () {
    return {
      lesson: true,
      editor: true,
      output: false,
    } as Navigation;
  },
  methods: {
    page (event: any, feature: string) {
      event.preventDefault();
      
      if (feature === 'lesson') {
        this.lesson = !this.lesson;
      } else if (feature === 'editor') {
        this.editor = !this.editor;
      } else if (feature === 'output') {
        this.output = !this.output;
      }

      store.dispatch("page", { feature });
    }
  }
});
